import { render, staticRenderFns } from "./RegisterFinancialIndex.vue?vue&type=template&id=56756626&"
import script from "./RegisterFinancialIndex.vue?vue&type=script&lang=js&"
export * from "./RegisterFinancialIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports